import script from "./SelectorPosicionFirma.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectorPosicionFirma.vue?vue&type=script&setup=true&lang=js"

import "./SelectorPosicionFirma.vue?vue&type=style&index=0&id=7054161c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7054161c"]])

export default __exports__